<template>
    <div class="overview-lead-generation-form">
        <v-dialog persistent v-model="dialog" overlay-opacity="0" content-class="overview-lead-form">
            <div class="lead-generation-form-container">
                <v-form @submit.prevent ref="overviewLeadFormRef">
                    <!-- header part  -->
                    <div class="heading flex">
                        <div class="back flex mr-2 pointer" @click="handleBackBtn()">
                            <v-icon color="#1D8D56">mdi-arrow-left</v-icon>
                        </div>
                        <h2 class="--green">Create Inquiry Form</h2>
                    </div>

                    <!-- form details  -->
                    <div class="form-container flex">
                        <div class="left-portion">
                            <label class="--font">Form name</label>
                            <v-text-field v-model="overviewData.name" class="mt-1" outlined :rules="appliedRules" placeholder="Choose a name for this inquiry form" />

                            <label class="--font">Header</label>
                            <v-text-field v-model="overviewData.heading" class="mt-1" outlined :rules="appliedRules" placeholder="Choose a name for this inquiry form" />

                            <label class="--font">Description</label>
                            <v-textarea
                                v-model="overviewData.description"
                                class="mt-1"
                                height="130"
                                outlined
                                :rules="appliedRules"
                                placeholder="Choose a name for this inquiry form"
                            />
                        </div>

                        <!-- image upload  -->
                        <div class="right-portion" @dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave" @dragover.prevent @drop.prevent>
                            <label class="--font">Upload lead image</label>
                            <input type="file" id="select-form-image" style="display: none" @change="selectImage($event, 'select')" />
                            <div class="upload__attach mt-1">
                                <label for="select-form-image" class="flex upload-image --green pointer">
                                    <img src="@/assets/MainDashboard/CreateContent/CreatePost/UploadImage.svg" alt="" />
                                    Upload from your computer
                                </label>
                            </div>

                            <div class="flex drop-zone" @drop.prevent="selectImage($event, 'drag')">
                                <p>Or drag and drop your files here</p>
                                <div class="images-preview-container flex">
                                    <div v-if="image">
                                        <img class="preview-image" :src="imagePreview" alt="" />
                                        <v-icon
                                            class="delete-image pointer"
                                            color="white"
                                            size="18"
                                            @click.native="
                                                image = null;
                                                imagePreview = '';
                                            "
                                        >
                                            mdi-close
                                        </v-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- button section  -->
                    <div class="buttons flex">
                        <button class="--green --weight discard" v-ripple @click="handleDiscardBtn()">Discard</button>
                        <button class="green-background white--text --weight" v-ripple @click="createForm">Save this form</button>
                    </div>
                </v-form>
                <v-progress-linear indeterminate class="mt-2" color="#1F8F58" v-if="loader"></v-progress-linear>
            </div>
        </v-dialog>

        <div v-if="createAdOverlay">
            <create-advertisement
                :cardSize="cardSize"
                :data="dataforApi"
                :createAdOverlay="createAdOverlay"
                @closeCreateAdOverlay="closeCreateAdOverlay"
                @cancelAdCreation="handleDiscardBtn()"
                @closeAll="reloadApi"
            />
        </div>
    </div>
</template>

<script>
import accessToken from "../../../../helpers/accessToken";
import rules from "../../../../helpers/rules";
import API_URL from "../../../../helpers/apiUrls";
import helper from "../../../../helpers/methods";
import createAdvertisement from "./create-advertisement.vue";
export default {
    name: "overviewLeadGenerationForm",
    components: {
        "create-advertisement": createAdvertisement,
    },
    data() {
        return {
            overviewData: {
                name: "",
                heading: "",
                description: "",
            },
            image: null,
            imagePreview: "",
            rules: rules,
            appliedRules: [],
            loader: false,
            createAdOverlay: false,
            dataforApi: this.data,
        };
    },

    computed: {
        // get input form data from store
        leadFormJSON() {
            return this.$store.getters["activeLeadsStore/GET_LEAD_FORM_JSON"];
        },
    },

    props: {
        dialog: {
            type: Boolean,
        },
        data: Object,
        cardSize: Array,
    },

    watch: {
        data: function () {
            console.log("DATA", data);
        },
        dialog: function (value) {
            if (!value) {
                (this.overviewData = {
                    name: "",
                    heading: "",
                    description: "",
                    success_text: "",
                }),
                    (this.imagePreview = "");
                this.image = null;
                this.loader = false;
                this.$refs.overviewLeadFormRef.reset();
            }
        },
    },

    methods: {
        handleBackBtn() {
            this.$emit("closeOverviewOverlay");
        },
        closeCreateAdOverlay() {
            this.createAdOverlay = false;
        },
        handleDiscardBtn() {
            if (this.createAdOverlay) this.createAdOverlay = false;
            this.$emit("closeAll");
        },
        reloadApi() {
            if (this.createAdOverlay) this.createAdOverlay = false;
            this.$emit("reloadApi");
        },
        dragEnter() {
            this.isDragged = true;
        },

        dragLeave() {
            this.isDragged = false;
        },

        selectImage(event, type = "select") {
            if (type === "drag") this.image = event.dataTransfer.files[0];
            else this.image = event.target.files[0];
            this.imagePreview = helper.provideImagePreviewURL([this.image])[0];
        },

        //create new form
        createForm() {
            this.appliedRules.push(this.rules.required);
            if (this.$refs.overviewLeadFormRef.validate()) {
                if (this.image === null) {
                    this.showToast("Please select an image!", "error", 5000);
                    return;
                }
                this.loader = true;
                const successHandler = (response) => {
                    if (response.status === 200) {
                        this.updateImage(response.data.id);
                    }
                };

                const errorHandler = (error) => {
                    this.showToast("Something went wrong internally!", "error", 10000);
                    console.log(error);
                };

                const headers = {
                    Authorization: `Bearer ${accessToken.getAccessToken()}`,
                    "BRAND-ID": localStorage.getItem("Brand-ID"),
                };

                const data = {...this.leadFormJSON, ...this.overviewData};

                this.requestPOST(API_URL.createContent__createForm, data, headers, successHandler, errorHandler);
            }
        },

        updateImage(ID) {
            const successHandler = (response) => {
                if (response.status === 200) {
                    // this.$emit("close");
                    // this.$emit("reset");
                    console.log("IUPDATE RESPONSE", response);
                    console.log("this.dataforApi", this.dataforApi);
                    this.dataforApi.form = response.data.id;
                    console.log("IN LEAD FORM--->", this.dataforApi);

                    this.showToast("Your form has been successfully created!");
                    this.loader = false;
                    this.createAdOverlay = true;
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error.response);
            };

            const data = new FormData();

            data.append("image", this.image);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            this.requestPOST(`${API_URL.createContent__form}${ID}/update`, data, headers, successHandler, errorHandler);
        },
    },
};
</script>

<style lang="scss" scoped>
.lead-generation-form-container {
    padding: 32px;
}

.heading {
    justify-content: flex-start;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
}

.back {
    background: #eff6f3;
    border-radius: 7px;
    width: 45px;
    height: 45px;
}

.form-container {
    margin-top: 30px;
    justify-content: space-between;
    align-items: flex-start;
}

.left-portion {
    width: 48%;
}

.right-portion {
    width: 48%;
}

.buttons {
    justify-content: space-between;
    position: sticky;
    bottom: 10px;
    margin-top: 40px;
}

.discard {
    background: #eff6f3;
    width: 29%;
}

.buttons button:not(.discard) {
    width: 69%;
    box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
}

.buttons button {
    border-radius: 5px;
    height: 50px;
}

label {
    font-size: 0.9rem;
}

.upload__attach label {
    border-radius: 5px;
    padding: 13px;
    font-size: 0.9rem;
}

.upload__attach label img {
    margin-right: 15px;
}

.upload-image {
    background: rgba(87, 215, 192, 0.05);
    width: 100%;
}

.drop-zone {
    flex-direction: column;
    background: #fbfdfc;
    border: 1px dashed #dbdbdb;
    border-radius: 7px;
    margin: 20px 0;
    padding: 60px 0;
    color: #c2cbc3;
    position: relative;

    p {
        margin: 0;
    }
}

.images-preview-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.images-preview-container > div {
    width: 120px;
    height: 120px;
    border-radius: 3px;
    margin: 0 5px;
}

.preview-image {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.delete-image {
    background-color: rgba(53, 52, 52, 0.47);
    border-radius: 50%;
    transform: translate(97px, -125px);
}
</style>

<style>
.overview-lead-form.v-dialog {
    width: 800px;
    min-height: 650px;
    border-radius: 12px;
    background-color: white;
    box-shadow: none;
}
</style>